//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Preloader from '@/components/other/Preloader'
import Pagination from "@/components/other/Pagination"
import CompilationsList from "~/components/compilations/CompilationsList"
import {getContentByCode} from "@/utils/utils";
export default {
  components: {
    Preloader,
    Pagination,
    CompilationsList
  },
  data () {
    return {
      loadedPage: false,
      section: null,
      pageSize: 8,
      loading: true
    }
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    }
  },
  watch: {

  },
  head() {
    const title = this.section?.name || (this.$i18n.locale === 'en' ? 'My Tretyakov' : 'Моя Третьяковка')
    const descr = this.section?.previewText

    let image = []

    if (this.section?.desktopPicture?.src) {
      const url = this.$absoluteImageUrl(this.section.desktopPicture.src)
      image = [
        { hid: 'og:image-url', property: 'og:image:url', content: url },
        { hid: 'og:image', property: 'og:image', content: url }
      ]
    }

    return {
      title: title,
      meta: [
        { hid: 'title', property: 'title', content: title},
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'description', property: 'description', content: descr },
        { hid: 'og:description', property: 'og:description', content: descr },
        ...image
      ]
    }
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'comp-section-text',
        auto: true,
        params: {
          code: ['podborki-see-all'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getSection () {
      const sectionCode = this.$route.params.section
      return {
        url: `/api/compilationsections/`,
        key: `compilation-section-list`,
        params: {
          lang: this.$i18n.locale || 'ru',
          section_code: sectionCode
        },
        on: {
          success () {
            this.section = this.getSection.data.data.items[0]
          }
        }
      }
    },
    getItems () {
      return {
        url: `/api/compilation/items/`,
        key: `compilation-section-items`,
        debounce: 1000,
        params: {
          lang: this.$i18n.locale || 'ru',
          page_size: this.pageSize,
          page: this.currentPage,
          section_id: this.section ? this.section.id : null
        },
        on: {
          loading () {
            this.loading = true
          },
          success () {
            if(this.loadedPage) {
              const anchor = document.querySelector('#galleryStart')
              if (typeof window !== 'undefined') {
                const anchor = document.querySelector('#galleryStart')
                if (anchor) {
                  window.scrollTo(0, anchor.offsetTop - 100);
                }
              }
            }
            if(!this.loadedPage) {
              this.loadedPage = true
            }
            this.loading = false

            const bodyEl = document.querySelector('body')
            bodyEl.style.overflow = 'visible'
          }
        }
      }
    }
  }
}
